// src/redux/settingsPages/accessibility/accessibilityActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import AccessibilityAPI from './accessibilityAPI';

export const fetchAccessibilitySettings = createAsyncThunk(
  'accessibility/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await AccessibilityAPI.getSettings();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load accessibility settings');
    }
  }
);

export const updateAccessibilitySettings = createAsyncThunk(
  'accessibility/update',
  async (patch, { rejectWithValue }) => {
    try {
      return await AccessibilityAPI.updateSettings(patch);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update accessibility settings');
    }
  }
);

export const resetAccessibilitySettings = createAsyncThunk(
  'accessibility/reset',
  async (_, { rejectWithValue }) => {
    try {
      return await AccessibilityAPI.resetSettings();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to reset accessibility settings');
    }
  }
);
